import { useContext } from 'react';
import { ThemeContext } from '../../app/theming/theme-context';

export const useTheme = () => {
  const theme = useContext(ThemeContext);
  if (!theme) throw new Error('useTheme must be used within ThemeProvider');
  return theme;
};
